var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main-content" }, [
    _c("div", { staticClass: "card" }, [
      _c("div", { staticClass: "card-body" }, [
        _c(
          "form",
          {
            on: {
              submit: function ($event) {
                $event.preventDefault()
                return _vm.getRecords()
              },
            },
          },
          [
            _c("div", { staticClass: "flex flex_gap" }, [
              _c("div", { staticClass: "form-group" }, [
                _c("label", [_vm._v("Период отчета")]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "input-group" },
                  [
                    _c("DateSelect", {
                      ref: "dateFrom",
                      attrs: { selectedDate: _vm.preset.date.from },
                    }),
                    _vm._v(" "),
                    _vm._m(0),
                    _vm._v(" "),
                    _c("DateSelect", {
                      ref: "dateTo",
                      attrs: { selectedDate: _vm.preset.date.to },
                    }),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _c("label", [_vm._v("Выберите пользователя")]),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.selectedUser,
                        expression: "selectedUser",
                      },
                    ],
                    staticClass: "form-control",
                    on: {
                      change: function ($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function (o) {
                            return o.selected
                          })
                          .map(function (o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.selectedUser = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      },
                    },
                  },
                  [
                    _c("option", { attrs: { value: "0" } }, [
                      _vm._v("Все пользователи"),
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.users, function (u) {
                      return _c("option", { domProps: { value: u.id } }, [
                        _vm._v(_vm._s(u.name)),
                      ])
                    }),
                  ],
                  2
                ),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "text-right mt-1" },
              [
                _c("LoadingButton", {
                  attrs: {
                    title: "Показать",
                    color: _vm.$constants.SUCCESS_COLOR,
                    type: "submit",
                    className: "btn btn-outline-success",
                    loading: _vm.loading,
                    onClick: () => {},
                  },
                }),
              ],
              1
            ),
          ]
        ),
      ]),
    ]),
    _vm._v(" "),
    _vm.loading || _vm.records
      ? _c("div", { staticClass: "card" }, [
          _c(
            "div",
            { staticClass: "card-body" },
            [
              _c("pulse-loader", {
                staticClass: "text-center",
                attrs: {
                  loading: _vm.loading,
                  color: _vm.$constants.LOADING_COLOR,
                },
              }),
              _vm._v(" "),
              !_vm.loading
                ? [
                    !_vm.records || !Object.keys(_vm.records).length
                      ? [_c("h5", [_vm._v("Записей не найдено")])]
                      : _c(
                          "table",
                          { staticClass: "table mt-1 table-sm table-hover" },
                          [
                            _vm._m(1),
                            _vm._v(" "),
                            _c(
                              "tbody",
                              [
                                _vm._l(
                                  _vm.records,
                                  function (oRecords, userId) {
                                    return [
                                      _c("tr", [
                                        _c(
                                          "td",
                                          {
                                            attrs: {
                                              rowspan:
                                                Object.keys(oRecords).length +
                                                1,
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.users[userId].name)
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          {
                                            attrs: {
                                              rowspan:
                                                Object.keys(oRecords).length +
                                                1,
                                            },
                                          },
                                          [
                                            _c("p", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.dialogs?.[userId]
                                                    ?.total_dialogs
                                                )
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            _c("p", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.getTotalOrders(userId)
                                                )
                                              ),
                                            ]),
                                          ]
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _vm._l(_vm.statusSort, function (status) {
                                        return oRecords[status]
                                          ? _c(
                                              "tr",
                                              { key: `${userId}_${status}` },
                                              [
                                                _c("td", [
                                                  _vm._v(
                                                    _vm._s(
                                                      oRecords[status]
                                                        .status_label
                                                    )
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _c("td", [
                                                  _vm._v(
                                                    _vm._s(
                                                      oRecords[status]
                                                        .total_orders
                                                    )
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _c("td", [
                                                  _vm._v(
                                                    _vm._s(
                                                      oRecords[status]
                                                        .total_price
                                                    )
                                                  ),
                                                ]),
                                              ]
                                            )
                                          : _vm._e()
                                      }),
                                    ]
                                  }
                                ),
                              ],
                              2
                            ),
                          ]
                        ),
                  ]
                : _vm._e(),
            ],
            2
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "input-group-prepend input-group-append" },
      [_c("span", { staticClass: "input-group-text" }, [_vm._v("по")])]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Пользователь")]),
        _vm._v(" "),
        _c("th", [_vm._v("Диалог"), _c("br"), _vm._v("заявка")]),
        _vm._v(" "),
        _c("th", [_vm._v("статус")]),
        _vm._v(" "),
        _c("th", [_vm._v("заявок")]),
        _vm._v(" "),
        _c("th", [_vm._v("на сумму")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }